export const kLinkPrivacyPolicyUrl = 'https://www.paxton.ai/legal/privacy-policy'
export const kLinkTermsOfServiceUrl = 'https://www.paxton.ai/legal/terms-of-service'

export const kPaxtonAppBaseDomain = () => {
  switch (import.meta.env.MODE) {
    case 'development': {
      return 'http://localhost:5173'
    }
    case 'staging': {
      return 'https://staging.paxton.ai'
    }
    case 'ephemeral': {
      return window.location.origin
    }
    case 'production': {
      return 'https://app.paxton.ai'
    }
    default: {
      return 'https://app.paxton.ai'
    }
  }
}

// Determine the Document Interface API base url by the environment
const kPaxtonAppApiCloudStaging = 'stagingapi.paxton.ai'
const kPaxtonAppApiCloudProduction = 'api2.paxton.ai'
const kPaxtonAppApiLocal = 'localhost:5002'

/**
 * Get the Paxton App API base URL for HTTP/HTTPS REST API requests
 * For WebSocket connections, use kPaxtonAppApiWebSocketBaseUrl() instead
 *
 * VITE_API_BASE_URL provides hostname-only (no protocol), used by ephemeral environments.
 * @returns The base URL with http:// or https:// scheme
 */
export const kPaxtonAppApiRESTBaseUrl = () => {
  const baseUrlOverride = import.meta.env.VITE_API_BASE_URL

  switch (import.meta.env.MODE) {
    case 'development': {
      return 'http://' + kPaxtonAppApiLocal
    }
    case 'ephemeral': {
      if (!baseUrlOverride) {
        throw new Error('VITE_API_BASE_URL is required for ephemeral REST API routing')
      }
      return 'https://' + baseUrlOverride
    }
    case 'staging': {
      return 'https://' + kPaxtonAppApiCloudStaging
    }
    case 'production': {
      return 'https://' + kPaxtonAppApiCloudProduction
    }
    default: {
      return 'https://' + kPaxtonAppApiCloudProduction
    }
  }
}

/**
 * Get the Paxton App API base URL for WebSocket connections
 * Use this function when creating WebSocket connections to ensure correct ws:// or wss:// scheme
 *
 * VITE_API_BASE_URL provides hostname-only (no protocol), used by ephemeral environments.
 * @returns The base URL with ws:// or wss:// scheme
 * @example
 * const url = kPaxtonAppApiWebSocketBaseUrl() + '/api/v1/assistant/chat/' + conversationId
 * const websocket = new WebSocket(url)
 */
export const kPaxtonAppApiWebSocketBaseUrl = () => {
  const baseUrlOverride = import.meta.env.VITE_API_BASE_URL

  switch (import.meta.env.MODE) {
    case 'development': {
      return 'ws://' + kPaxtonAppApiLocal
    }
    case 'ephemeral': {
      if (!baseUrlOverride) {
        throw new Error('VITE_API_BASE_URL is required for ephemeral WebSocket routing')
      }
      return 'wss://' + baseUrlOverride
    }
    case 'staging': {
      return 'wss://' + kPaxtonAppApiCloudStaging
    }
    case 'production': {
      return 'wss://' + kPaxtonAppApiCloudProduction
    }
    default: {
      return 'wss://' + kPaxtonAppApiCloudProduction
    }
  }
}
